module.exports = __webpack_public_path__ + "img/pin_exchange_green.be96e85e.svg";